module.exports = __webpack_public_path__ + "static/media/img_handbike.16114a01.jpg";